import { useEffect, useState } from "react";

/**
 * [zgłoszenie właściciela 2026-09-16] TELEFON = PODSTAWOWA PRACA UŻYTKOWNIKA.
 *
 *   „Usuń mi cały widget dla wyszukiwarki dla urządzeń mobilnych, to samo wyłącz mi przyciski
 *    obsługi HR/ITSM (…) nie ma ich w header!!! Zablokuj wejście do sekcji admin z urządzeń
 *    mobilnych, urządzenie mobilne ma być dla usera do podstawowych prac w zakresie korzystania
 *    z aplikacji — mój dział ma być, ale moduły — wejście do obsługi oraz wyszukiwarka jest
 *    wyłączona."
 *
 * Granica telefonu była dotąd PRYWATNĄ stałą `UIContext` (`MOBILE_BREAKPOINT`), a `isMobile`
 * dostawało się wyłącznie przez `useUI()`. To nie wystarcza: `useUI` RZUCA poza `UIProvider`,
 * więc osłona trasy (`ProtectedRoute`) — montowana także w testach bez tego dostawcy — nie mogła
 * z niego skorzystać. Zamiast drugiej, rozjeżdżającej się liczby w drugim pliku, granica mieszka
 * tutaj, a `UIContext` ją stąd bierze. Jedna liczba, dwa sposoby odczytu:
 *   • `useUI().isMobile` — tam, gdzie kontekst i tak jest (nagłówek, menu boczne),
 *   • `useTelefon()`     — tam, gdzie kontekstu może nie być (osłona trasy).
 *
 * ⚠️ To jest ROZMIAR OKNA, nie „typ urządzenia": wąskie okno na komputerze też jest traktowane
 * jak telefon. Tak było dotąd w całej aplikacji (menu, szuflady) i tak zostaje — inaczej te same
 * ekrany zachowywałyby się różnie w zależności od tego, kto je pyta.
 */
export const SZEROKOSC_TELEFONU = 768;

/** Czy okno ma szerokość telefonu. Poza przeglądarką (SSR, testy bez okna) — nie. */
export const czyTelefon = () =>
    typeof window !== "undefined" && typeof window.innerWidth === "number"
        ? window.innerWidth <= SZEROKOSC_TELEFONU
        : false;

/** Ta sama granica, ale jako stan reagujący na zmianę rozmiaru okna (obrót telefonu). */
export const useTelefon = () => {
    const [telefon, setTelefon] = useState(czyTelefon);

    useEffect(() => {
        const przelicz = () => setTelefon(czyTelefon());
        przelicz();
        window.addEventListener("resize", przelicz);
        return () => window.removeEventListener("resize", przelicz);
    }, []);

    return telefon;
};
